import { createContext } from 'react';

export const OrderFormContext = createContext();
